module.exports = __webpack_public_path__ + "img/slider-arrow-next.431a169fe39268dbb95b364d3542373d.svg";